<app-core-offcanvas
  headerTitle="{{'management.authorization.detail-user-role' | translate}}"
  [width]="'100%'"
  [showSaveButton]="false"
  #canvas
>
  <div class="row">

    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="card">
        <div class="card-body bg-secondary">
          <div class="row">
            <div class="col-lg-1 col-md-2 col-sm-3">
              <img
                [src]="user?.staff?.photo ? user.staff.photo : './assets/theme/w3crm/images/profile/friends/f1.jpg'"
                class="rounded-circle mb-0 " style="width: 100px; height: 100px; margin: auto;" alt="">
            </div>
            <div class="col-lg-3 col-md-3 col-sm-9">
              <h2 class="text-white ">{{ user?.firstName }} {{ user?.lastName }}</h2>
              <p-dropdown
                [options]="roles"
                [(ngModel)]="selectedRoleItem"
                (ngModelChange)="onRoleChange()"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
              ></p-dropdown>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <div class="text-white">
                <ul class="text-white list-group list-group-flush me-4">
                  <li class="list-group-item d-flex column-gap-2 p-1 text-white">
                    <span class="">{{ 'general.department' | translate }}: </span>
                    <span>{{ user?.department ? user?.department.department : '' }}</span></li>
                  <li class="list-group-item d-flex column-gap-2 p-1 text-white">
                    <span class="">{{ 'general.department' | translate }}: </span>
                    <span>{{ user?.position }}</span></li>

                </ul>

              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6">
              <div class="text-white">
                <ul class="text-white list-group list-group-flush">

                  <li class="list-group-item d-flex column-gap-2  p-2 text-white">
                    <span class="">{{ 'general.email' | translate }}: </span>
                    <span>{{ user?.email }}</span>
                  </li>
                  <li class="list-group-item d-flex column-gap-2  p-2 text-white">
                    <span class="">{{ 'general.phone' | translate }}: </span>
                    <span>{{ user?.phone }}</span>
                  </li>
                </ul>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-4 col-md-6 col-sm-12 mb-4">
      <app-cards
        [title]="'management.authorization.authority-group.header' | translate"
        headerStyle="bg-success"
        whiteHeader="text-white"
        footerDivider="border-0 pb-0 "
        styleBody="px-0"
      >
        <div headerRight></div>
        <div bodyContent>
          <div class=" px-3 mb-4">
            <input type="search" class="form-control "
                   [placeholder]="('common.search' |translate)"
                   [(ngModel)]="searchAuthorityGroup"
                   (input)="handleAuthorityGroupSearch()"
            ></div>
          <ng-container>
            <div>
              <div *ngIf="filteredAuthorityGroups?.length === 0" class="text-center text-muted py-3">
                <app-empty-data
                  [title]="('management.authorization.authority-group.empty-title'  | translate )"
                  [message]="('management.authorization.authority-group.empty-msg'  | translate )"
                  icon="mdi mdi-information-outline"
                  containerClass="opacity-50"
                  iconSize="40px"
                  iconColor="gray"
                  titleSize="10px"
                  titleColor="gray"
                  messageSize="14px"
                  messageColor="gray"
                ></app-empty-data>
              </div>
              <div
                class="d-flex align-items-center justify-content-between custom-hover pt-2"
                [ngClass]="{ 'left-line-active': item?.id === selectedAuthorityGroup?.id }"
                *ngFor="let item of filteredAuthorityGroups"
              >
                <button
                  class="p-3 btn text-start flex-grow-1"
                  (click)="onAuthorityGroupSelect(item)"
                ><span class="role-name ">{{ item.authorityGroupName }}</span>
                  <div class="text-muted small">{{ item.description }}</div>
                </button>

              </div>
            </div>
          </ng-container>
        </div>
      </app-cards>
    </div>

    <div class="col-lg-4 col-md-6 col-sm-12 mb-4">
      <app-cards
        [title]="'management.authorization.authority.header' | translate"
        headerStyle="bg-info"
        whiteHeader="text-white"
        footerDivider="border-0 pb-0 "
        styleBody="px-0"
      >
        <div headerRight></div>
        <div bodyContent>
          <div class=" px-3 mb-4">
            <input type="search" class="form-control "
                   [placeholder]="('common.search' |translate)"
                   [(ngModel)]="searchAuthority"
                   (input)="handleAuthoritySearch()"
            ></div>
          <ng-container>
            <div>
              <div *ngIf="filteredAuthorities?.length === 0" class="text-center text-muted py-3">
                <app-empty-data
                  [title]="('management.authorization.authority.empty-title'  | translate )"
                  [message]="('management.authorization.authority.empty-msg'  | translate )"
                  icon="mdi mdi-information-outline"
                  containerClass="opacity-50"
                  iconSize="40px"
                  iconColor="gray"
                  titleSize="10px"
                  titleColor="gray"
                  messageSize="14px"
                  messageColor="gray"
                ></app-empty-data>
              </div>
              <div
                class="d-flex align-items-center justify-content-between custom-hover pt-2"
                [ngClass]="{ 'left-line-active': item?.id === selectedAuthority?.id }"
                *ngFor="let item of filteredAuthorities"
              >
                <button
                  class="p-3 btn text-start flex-grow-1"
                  (click)="onAuthoritySelect(item)"
                ><span class="role-name ">{{ item.authorityName }}</span>
                  <div class="text-muted small">{{ item.description }}</div>
                </button>

              </div>
            </div>
          </ng-container>
        </div>
      </app-cards>
    </div>

    <div class="col-lg-4 col-md-6 col-sm-12 mb-4">
      <app-cards
        [title]="'management.authorization.action.header' | translate"
        headerStyle="bg-warning"
        whiteHeader="text-white"
        footerDivider="border-0 pb-0 "
        styleBody="px-0"
      >
        <div headerRight></div>
        <div bodyContent>
          <div class=" px-3 mb-4">
            <input type="search" class="form-control "
                   [placeholder]="('common.search' |translate)"
                   [(ngModel)]="searchAction"
                   (input)="handleActionSearch()"
            ></div>
          <ng-container>
            <div>
              <div *ngIf="filteredActions?.length === 0" class="text-center text-muted py-3">
                <app-empty-data
                  [title]="('management.authorization.action.empty-title'  | translate )"
                  [message]="('management.authorization.action.empty-msg'  | translate )"
                  icon="mdi mdi-information-outline"
                  containerClass="opacity-50"
                  iconSize="40px"
                  iconColor="gray"
                  titleSize="10px"
                  titleColor="gray"
                  messageSize="14px"
                  messageColor="gray"
                ></app-empty-data>
              </div>
              <div
                class="d-flex align-items-center justify-content-between custom-hover pt-2"
                *ngFor="let item of filteredActions"
              >
                <button
                  class="p-3 btn text-start flex-grow-1"
                ><span class="role-name ">{{ item.name }}</span>
                  <div class="text-muted small">{{ item.key }}</div>
                </button>

                <div class="d-flex flex-nowrap">
                  <div class="form-check custom-checkbox me-3">
                    <input type="checkbox" class="form-check-input"
                           [checked]="item[ActionTypeEnum.R.toLowerCase()]"
                           (change)="toggleActionType(item, ActionTypeEnum.R.toLowerCase())"
                           id="customCheckBoxRead{{item.id}}">
                    <label class="form-check-label text-primary"
                           for="customCheckBoxRead{{item.id}}">R</label>
                  </div>
                  <div class="form-check custom-checkbox me-3 checkbox-info">
                    <input type="checkbox" class="form-check-input"
                           [checked]="item[ActionTypeEnum.C.toLowerCase()]"
                           (change)="toggleActionType(item, ActionTypeEnum.C.toLowerCase())"
                           id="customCheckBoxCreate{{item.id}}">
                    <label class="form-check-label text-info"
                           for="customCheckBoxCreate{{item.id}}">C</label>
                  </div>
                  <div class="form-check custom-checkbox me-3 checkbox-success">
                    <input type="checkbox" class="form-check-input"
                           [checked]="item[ActionTypeEnum.U.toLowerCase()]"
                           (change)="toggleActionType(item, ActionTypeEnum.U.toLowerCase())"
                           id="customCheckBoxUpdate{{item.id}}">
                    <label class="form-check-label text-success"
                           for="customCheckBoxUpdate{{item.id}}">U</label>
                  </div>
                  <div class="form-check custom-checkbox me-3 checkbox-warning">
                    <input type="checkbox" class="form-check-input"
                           [checked]="item[ActionTypeEnum.D.toLowerCase()]"
                           (change)="toggleActionType(item, ActionTypeEnum.D.toLowerCase())"
                           id="customCheckBoxDelete{{item.id}}">
                    <label class="form-check-label text-warning"
                           for="customCheckBoxDelete{{item.id}}">D</label>
                  </div>
                </div>

              </div>
            </div>
          </ng-container>
        </div>
      </app-cards>
    </div>
  </div>
</app-core-offcanvas>
